<template>
  <b-card
    no-body
    tag="article"
    class="mb-3 mr-3"
  >
    <h4 slot="header" class="mb-0">
      <i class="fas fa-exclamation-circle"></i>
      <span class="pl-2">{{site.label}}</span>
    </h4>
    <b-card-body>
      <p class="card-text">
        <table class="table site-table">
          <tbody>
            <tr>
              <th scope="row">Device</th>
              <td v-html="devices"></td>
            </tr>
            <tr>
              <th scope="row">Site</th>
              <td>Ha</td>
            </tr>
            <tr>
              <th scope="row">Send To</th>
              <td v-html="targets"></td>
            </tr>
          </tbody>
        </table>

        <b-button @click.stop="$emit('edit-site')" size="sm" variant="primary" class="mr-1"><i class="fas fa-edit"></i><span class="pl-2">Edit</span></b-button>
        <b-button @click.stop="deleteSite()" v-if="site.id" size="sm" variant="danger" class="mr-1"><i class="fas fa-trash"></i><span class="pl-2">Delete</span></b-button>
      </p>
    </b-card-body>
  </b-card>
</template>

<script>
import moment from 'moment-timezone'
// import { DELETE_SITE_MUTATION, UPDATE_SITE_MUTATION } from '@/constants/graphql'

export default {
  name: 'SiteCard',
  props: {
    site: {
      type: Object,
      default () {
        return {
          id: null,
          enabled: true,
          label: null,
          method: null,
          destination: null
        }
      }
    }
  },
  data () {
    return {
      loading: 0,
      error: null,
      methodOptions: [
        { value: null, text: 'Please select a method' },
        { value: 'EMAIL', text: 'Email' },
        { value: 'SMS', text: 'Text Message' }
      ]
    }
  },
  methods: {
    getFormattedSite (site) {
      return `${site.name}`
    },
    formatSeconds (numSeconds) {
      return moment.utc(numSeconds * 1000).format('m')
    }
  }
}
</script>

<style>
table.site-table tbody tr:first-child td, table.site-table tbody tr:first-child th {
  border-top: none !important;
}
.card-header h4 {
    font-size: 1.2em;
    line-height: 1.2em;
}
article.card {
  width: 22rem;
  min-width: 20rem;
  max-width: 25rem;
}
article.card {
  background-color: rgba(255,255,255, 0.9);
}
</style>
